import { Component } from '@angular/core';

import { BaseComponent } from '@ridango/core';

@Component({
    selector: 'gl-isic-card-activation-page',
    templateUrl: './isic-card-activation-page.component.html',
    styleUrls: ['./isic-card-activation-page.component.scss']
})
export class IsicCardActivationPageComponent extends BaseComponent {}
